const startWhitespace = /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]*/;
const endWhitespace = /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]*$/;

export class StringHelper {
    /**
     * Joins list of strings to complete string
     * @param stringList
     * @param fallbackIfNull
     */
    static stringListToString = (stringList: string[], fallbackIfNull: string = null): string => {
        return (stringList) ? stringList.join('') : fallbackIfNull;
    };

    /**
     * The trim() method removes whitespace from both ends of a string.
     * @param string
     */
    static trim = (string: string): string => {
        return string.replace(startWhitespace, '').replace(endWhitespace, '');
    }

    /**
     * The trimStart() method removes whitespace from the beginning of a string.
     * @param string
     */
    static trimStart = (string: string): string => {
        return string.replace(startWhitespace, '');
    }

    /**
     * The trimEnd() method removes whitespace from the end of a string.
     * @param string
     */
    static trimEnd = (string: string): string => {
        return string.replace(endWhitespace, '');
    }

    private static _validRandomHashChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

    /**
     * Generates a random alpha numeric hash
     *
     * @param length
     */
    static generateRandomHash = (length: number): string => {
        const max = StringHelper._validRandomHashChars.length;
        let hash = [];
        for (let i = 0; i < length; i++) {
            hash.push(StringHelper._validRandomHashChars.charAt(Math.floor(Math.random() * max)));
        }

        return hash.join("");
    }

    /**
     * Interpolate string by data from data.
     * Supported are objects and array.
     *
     * Examples
     * StringHelper.interpolate('Hi {name}!', {name: 'bela'}) // 'Hi bela!'
     * StringHelper.interpolate('Hi {0}, {1} and {2}!', ['Bela', 'Archibald', 'Steve']) // 'Hi Bela, Archibald and Steve!'
     * StringHelper.interpolate('Hi {name1}, {name2.name} {name2.familyName} and {name3}!', {
                    name1: 'bela1',
                    name2: { name: 'Bela', familyName: 'Wtf'},
                    name3: 'bela3'
                }) // 'Hi bela1, Bela Wtf and bela3!'
     *
     * @param text
     * @param data
     */
    static interpolate = (text: string, data: any): string => {
        return StringHelper.interpolateInner(text, data, [])
    }

    private static interpolateInner = (text: string, data: any, prepends:string[]): string => {
        if (!data) {
            return text;
        }

        const prepend = prepends.length > 0 ? prepends.join(".") + "." : "";

        Object.keys(data)?.map(key => {
            // if object iterate over inner values
            if(typeof data[key] === "object" && data.hasOwnProperty(key)) {
                text = StringHelper.interpolateInner(text, data[key], [...prepends, key]);
            } else {
                text = text.replace(`{${prepend}${key}}`, data[key]);
            }

        });

        return text;
    }
}